import { useEffect, useState } from "react";
import { Form, Spinner, Table } from "react-bootstrap";
import { BiDotsHorizontalRounded } from "react-icons/bi";
import BarChart from "components/barChart";
import { FiArrowDownLeft, FiArrowUpRight } from "react-icons/fi";
import { HiOutlineEye } from "react-icons/hi";
import GraphShadowIcon from "components/graph-shadow-icon";
import "../../styles/subscription.css";
import ModalComponent from "components/modal-component";
import { AiOutlineClose } from "react-icons/ai";
import Logo from "../../assets/images/logo.svg";
import Chart from "react-apexcharts";
import {
  DashboardQuery,
  SubCompanyPagination,
  SubscriptionCompany,
  SubscriptionPercentage,
  SubscriptionSummaryTotal,
} from "model/dashboardModel";
import {
  // useDeleteCompanyMutation,
  useGetSubscriptionCompanyQuery,
  useGetSubscriptionPercentageQuery,
} from "api/dashboardApi";
import { useDeleteCompanyMutation } from "api/config/externalApi";
import { FormattedDateTime } from "components/formatted-date";
import emptyFile from "../../assets/images/emptydata.gif";
import {
  showToastError,
  showToastSuccess,
} from "components/toastify/ToastNotifications";
import Pagination from "rc-pagination";
import "rc-pagination/assets/index.css";
import info from "../../assets/images/info.gif";

type Props = {
  summaryData: any;
  customDate: any;
  refresh: boolean;
};

// Static data for Monthly Performance Metrics table
const monthlyPerformanceData = [
  {
    month: "Aug",
    totalMinutes: 42000,
    successRate: 80,
    avgDuration: "38s",
    revenue: "€21,000",
    cost: "€6,300",
    profitMargin: "70.0%",
  },
  {
    month: "Jul",
    totalMinutes: 42000,
    successRate: 80,
    avgDuration: "38s",
    revenue: "€21,000",
    cost: "€6,300",
    profitMargin: "70.0%",
  },
  {
    month: "Jun",
    totalMinutes: 42000,
    successRate: 80,
    avgDuration: "38s",
    revenue: "€21,000",
    cost: "€6,300",
    profitMargin: "70.0%",
  },
  {
    month: "May",
    totalMinutes: 42000,
    successRate: 80,
    avgDuration: "38s",
    revenue: "€21,000",
    cost: "€6,300",
    profitMargin: "70.0%",
  },
  {
    month: "Apr",
    totalMinutes: 42000,
    successRate: 80,
    avgDuration: "38s",
    revenue: "€21,000",
    cost: "€6,300",
    profitMargin: "70.0%",
  },
  {
    month: "Mar",
    totalMinutes: 42000,
    successRate: 80,
    avgDuration: "38s",
    revenue: "€21,000",
    cost: "€6,300",
    profitMargin: "70.0%",
  },
  {
    month: "Feb",
    totalMinutes: 42000,
    successRate: 80,
    avgDuration: "38s",
    revenue: "€21,000",
    cost: "€6,300",
    profitMargin: "70.0%",
  },
  {
    month: "Jan",
    totalMinutes: 42000,
    successRate: 80,
    avgDuration: "38s",
    revenue: "€21,000",
    cost: "€6,300",
    profitMargin: "70.0%",
  },
];

// Static data for Multi-Language Performance table
const multiLanguageData = [
  {
    language: "English",
    totalMinutes: 28000,
    successRate: 80,
    marketShare: "60.0%",
    supportedRegions: "America, Europe",
    performance: "Excellent",
  },
  {
    language: "German",
    totalMinutes: 28000,
    successRate: 80,
    marketShare: "20.0%",
    supportedRegions: "Europe",
    performance: "Excellent",
  },
  {
    language: "French",
    totalMinutes: 28000,
    successRate: 80,
    marketShare: "15.0%",
    supportedRegions: "Africa, Europe",
    performance: "Excellent",
  },
  {
    language: "Spanish",
    totalMinutes: 28000,
    successRate: 80,
    marketShare: "10.0%",
    supportedRegions: "America",
    performance: "Excellent",
  },
  {
    language: "Portuguese",
    totalMinutes: 28000,
    successRate: 60,
    marketShare: "5.0%",
    supportedRegions: "Africa",
    performance: "Good",
  },
];

const callTypeData = [
  {
    callType: "Appointment Booking",
    totalMinutes: 28000,
    successRate: 80,
    avgDuration: "40s",
    revenueShare: "60.0%",
    performance: "Excellent",
  },
  {
    callType: "General Awareness",
    totalMinutes: 28000,
    successRate: 80,
    avgDuration: "40s",
    revenueShare: "20.0%",
    performance: "Excellent",
  },
  {
    callType: "Follow-up calls",
    totalMinutes: 28000,
    successRate: 80,
    avgDuration: "40s",
    revenueShare: "15.0%",
    performance: "Excellent",
  },
];

const SophiaVoiceAgent = ({ summaryData, customDate, refresh }: Props) => {
  const [loading, setLoading] = useState(false);
  const [smallLoading, setSmallLoading] = useState(false);
  const [loadingTable, setLoadingTable] = useState(false);
  const [activityTab, setActivityTab] = useState("Subscribers");
  const [activePlan, setActivePlan] = useState("All");
  const [activeUser, setActiveUser] = useState("All");
  const [showMonthlyTable, setShowMonthlyTable] = useState(true);
  const [showLanguageTable, setShowLanguageTable] = useState(true);

  const [showCallTypeTable, setShowCallTypeTable] = useState(true);

  //Comment this out so that thdhdhd
  const [selectedCompany, setSelectedCompany] = useState<SubscriptionCompany>();
  const [show, setShow] = useState(false);
  const [smallShow, setSmallShow] = useState(false);
  const [activeModalTab, setActiveModalTab] = useState("history");

  const [subSummaryTotal, setSubSummaryTotal] =
    useState<SubscriptionSummaryTotal>();

  let query: DashboardQuery = {
    application: summaryData?.selectedPackage,
    periodFilter:
      summaryData?.subMenuSearch === "OneMonth" ||
      summaryData?.subMenuSearch === "ThreeMonths" ||
      summaryData?.subMenuSearch === "OneYear" ||
      summaryData?.subMenuSearch === "AllTime" ||
      summaryData?.subMenuSearch === "Custom"
        ? summaryData?.subMenuSearch
        : "AllTime",
    fromDate: customDate?.startDate,
    toDate: customDate?.endDate,
  };

  //Use the useGetAllTicketQuery hook with the query object
  // const { data: getSubSummary, error: getSubSummaryError, isFetching: getSubSummaryisFetching } = useGetSubscriptionSummaryQuery(query);

  // useEffect(() => {
  //     if (getSubSummaryisFetching) {
  //         setLoading(true);
  //     }
  //     else {
  //         setLoading(false);
  //         if (getSubSummaryError) {
  //             showToastError('Unable to fetch data from the server');
  //         }
  //         else {
  //             setSubSummaryTotal(getSubSummary?.data as SubscriptionSummaryTotal);
  //         }
  //     }
  // }, [getSubSummaryisFetching, summaryData]);

  const [subSummaryPercentage, setSubSummaryPercentage] =
    useState<SubscriptionPercentage>();
  const {
    data: getSubSummaryPercentage,
    error: getSubSummaryPercentageError,
    isFetching: getSubSummaryPercentageisFetching,
    refetch: getSubSummaryPercentageRefetching,
  } = useGetSubscriptionPercentageQuery(query);

  useEffect(() => {
    if (getSubSummaryPercentageisFetching) {
      setLoading(true);
    } else {
      setLoading(false);
      if (getSubSummaryPercentageError) {
        showToastError("Unable to fetch data from the server");
      } else {
        setSubSummaryPercentage(
          getSubSummaryPercentage?.data as SubscriptionPercentage
        );
      }
    }
  }, [getSubSummaryPercentageisFetching, summaryData, refresh]);

  const [pageNumber, setPageNumber] = useState<number>(1);
  const [queryParameters, setQueryParameters] = useState<DashboardQuery>({
    application: summaryData?.selectedPackage,
    periodFilter:
      summaryData?.subMenuSearch === "OneMonth" ||
      summaryData?.subMenuSearch === "ThreeMonths" ||
      summaryData?.subMenuSearch === "OneYear" ||
      summaryData?.subMenuSearch === "AllTime" ||
      summaryData?.subMenuSearch === "Custom"
        ? summaryData?.subMenuSearch
        : "AllTime",
    page: pageNumber,
    pageSize: 10,
  });
  // let queryParameters: DashboardQuery = {
  //     application: summaryData?.selectedPackage,
  //     periodFilter: summaryData?.subMenuSearch === 'OneMonth' || summaryData?.subMenuSearch === 'ThreeMonths' || summaryData?.subMenuSearch === 'OneYear' || summaryData?.subMenuSearch === 'AllTime' || summaryData?.subMenuSearch === 'Custom' ? summaryData?.subMenuSearch : 'OneMonth',
  //     page: pageNumber,
  //     pageSize: 10,
  // };

  const [subCompanyPagination, setSubCompanyPagination] =
    useState<SubCompanyPagination>();
  const [subCompany, setSubCompany] = useState<SubscriptionCompany[]>([]);
  const sunCompanyFilterTest = [
    // put static table data here
  ];
  const [subCompanyFilter, setSubCompanyFilter] = useState<
    SubscriptionCompany[]
  >([]);
  const {
    data: getSubCompany,
    error: getSubCompanyError,
    isFetching: getSubCompanyisFetching,
    refetch: refetchSubCompany,
  } = useGetSubscriptionCompanyQuery(queryParameters);

  useEffect(() => {
    if (getSubCompanyisFetching) {
      setLoadingTable(true);
    } else {
      if (getSubCompanyError) {
        showToastError("Unable to fetch data from the server");
      } else {
        setSubCompanyPagination(getSubCompany?.data as SubCompanyPagination);
        setSubCompany(getSubCompany?.data?.items as SubscriptionCompany[]);
        setSubCompanyFilter(
          getSubCompany?.data?.items as SubscriptionCompany[]
        );
      }
      setLoadingTable(false);
    }
  }, [getSubCompanyisFetching, summaryData, refresh]);

  // Function to handle page change
  const onPageChange = async (page: number) => {
    setQueryParameters((prev) => ({ ...prev, page: page }));
    // You can perform actions like fetching data for the new page here
  };

  useEffect(() => {
    refetchSubCompany();
    getSubSummaryPercentageRefetching();
  }, [queryParameters?.page]);

  const trendDates = ["Most Recent", "Lowest First", "Company Staff Size"];

  const chartCountName =
    subSummaryPercentage &&
    subSummaryPercentage?.plans?.map((item) => item?.name);
  const chartSubCount =
    subSummaryPercentage &&
    subSummaryPercentage?.plans?.map((item) => item?.subscriptionCount);

  const subscription = {
    options: {
      chart: { id: "basic-bar", stacked: true },
      plotOptions: {
        bar: { borderRadius: 5, horizontal: true, barHeight: "50%" },
      },
      dataLabels: { enabled: false },
      xaxis: { categories: chartCountName || [0, 0, 0, 0] },
      yaxis: {
        show: true,
        labels: { show: true, minWidth: 80, maxWidth: 150 },
      },
      fill: { colors: ["#BC48D9", "rgba(188, 72, 217, 0.15)"] },
      tooltip: { enabled: false },
    },
    series: [
      {
        name: "Active subscribers",
        data: chartSubCount || [0, 0, 0, 0],
        color: "#BC48D9",
      },
      // { name: 'All time subscribers', data: chartSubCount || [0, 0, 0, 0], color: 'rgba(188, 72, 217, 0.15)', },
    ],
    type: "bar",
    width: 500,
    height: 300,
  };

  const revenue = {
    options: {
      chart: { id: "basic-bar", stacked: true },
      plotOptions: {
        bar: { borderRadius: 5, horizontal: true, barHeight: "50%" },
      },
      dataLabels: { enabled: false },
      xaxis: { categories: chartCountName || [0, 0, 0, 0] },
      yaxis: {
        show: true,
        labels: { show: true, minWidth: 80, maxWidth: 150 },
      },
      fill: { colors: ["#21A600", "rgba(33, 150, 83, 0.1)"] },
      tooltip: { enabled: false },
    },
    series: [
      {
        name: "Projects created",
        data: chartSubCount || [0, 0, 0, 0],
        color: "#21A600",
      },
      {
        name: "Estimated Project creation",
        data: chartSubCount || [0, 0, 0, 0],
        color: "rgba(33, 150, 83, 0.1)",
      },
    ],
    type: "bar",
    width: 600,
    height: 300,
  };

  const handleFilter = (product: any) => {
    setActivePlan(product);
    if (product) {
      setSubCompanyFilter(
        subCompany?.filter((item) => item?.planName === product)
      );
    }
  };

  const [menuopen, setMenuopen] = useState<boolean>(false);
  const [selected, setSelected] = useState<any[]>([]);
  const addSelected = (val: any) => {
    const sel = selected || [];
    let k = sel.find((v) => v.email === val.email);
    k ? sel.splice(sel.indexOf(k), 1) : sel.push(val);
    setSelected(() => [...sel]);
    
  };

  function handleDeleteCompany() {
    selected.map((k) => {
      deleteCompany(k.subdomain);
    });
  }

  const [deleteComp] = useDeleteCompanyMutation();

  const deleteCompany = async (subdomain: string) => {
    try {
      setSmallLoading(true);
      const response = await deleteComp(subdomain).unwrap();
      if (response) {
        setSmallLoading(false);
        showToastSuccess(response?.ResponseMessage);
        setSmallShow(false);
        refetchSubCompany();
      }
    } catch (error: any) {
      setSmallLoading(false);
      showToastError(
        error?.data.ResponseMessage || `Error deleting company ${subdomain}`
      );
    }
  };

  const totalSubscriptions = subSummaryPercentage?.plans?.reduce(
    (sum, plan) => sum + plan.subscriptionCount,
    0
  );

  const series = [60, 25, 15]; // percentages for each category

  const options = {
    chart: {
      type: "donut" as const,
      height: 350,
    },
    labels: ["Appointment Booking", "General Awareness", "Follow-up calls"],
    colors: ["#28a745", "#007bff", "#fd7e14"], // Green, Blue, Orange to match the image
    dataLabels: {
      enabled: false, // Hide data labels on the chart itself
    },
    legend: {
      show: false, // We'll create custom legend
    },
    plotOptions: {
      pie: {
        donut: {
          size: "70%", // Creates the donut effect
        },
      },
    },
    stroke: {
      width: 0, // Remove borders between segments
    },
    tooltip: {
      y: {
        formatter: function (val: number) {
          return val + "%";
        },
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 300,
          },
        },
      },
    ],
  };

  const legendItems = [
    { color: "#28a745", label: "Appointment Booking", value: 60 },
    { color: "#007bff", label: "General Awareness", value: 25 },
    { color: "#fd7e14", label: "Follow-up calls", value: 15 },
  ];

  return (
    <div className="mt-4">
      <h5 className="fw-bold mb-4">Sophia Voice Agent</h5>
      {loading ? (
        <div style={{ textAlign: "center", padding: "3rem", margin: "auto" }}>
          <Spinner />
          <br />
          <h4>loading...</h4>
        </div>
      ) : (
        <div style={{ display: "flex", gap: "1rem" }}>
          <div style={{ flex: 1, marginRight: "1rem" }}>
            {activityTab === "Subscribers" && (
              <div
                style={{
                  padding: "1.5rem 2rem",
                  backgroundColor: "#fff",
                  borderRadius: "1rem",
                }}
              >
                {/* <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <span style={{ fontSize: "1.1rem", fontWeight: 500 }}>
                    {summaryData?.selectedPackage} Subscription Activity{" "}
                    <BiDotsHorizontalRounded />
                  </span>
                  <div
                    style={{
                      width: "50%",
                      display: "flex",
                      alignItems: "flex-end",
                      justifyContent: "flex-end",
                    }}
                  >
                    <Form.Select
                      value={activityTab}
                      onChange={(e) => setActivityTab(e.target.value)}
                      style={{
                        width: "75%",
                        borderRadius: "50px",
                        padding: "0.25rem 0.5rem",
                      }}
                    >
                      <option value="Subscribers">Subscribers</option>
                      <option value="Revenue">Revenue</option>
                    </Form.Select>
                  </div>
                </div> */}
                <div className="">
                  <p className="fw-bold" style={{ fontSize: "16px" }}>
                    Peak Usage Hours
                  </p>
                  <p className="dark-text">
                    Call volume distribution throughout the day
                  </p>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                  }}
                >
                  <BarChart {...subscription} />
                </div>
              </div>
            )}

            {activityTab === "Revenue" && (
              <div
                style={{
                  padding: "1.5rem 2rem",
                  backgroundColor: "#fff",
                  borderRadius: "1rem",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <span style={{ fontSize: "1.1rem", fontWeight: 500 }}>
                    {summaryData?.selectedPackage} Revenue Activity{" "}
                    <BiDotsHorizontalRounded style={{ marginLeft: "1rem" }} />
                  </span>
                  <div
                    style={{
                      width: "50%",
                      display: "flex",
                      alignItems: "flex-end",
                      justifyContent: "flex-end",
                    }}
                  >
                    <Form.Select
                      value={activityTab}
                      onChange={(e) => setActivityTab(e.target.value)}
                      style={{
                        width: "75%",
                        borderRadius: "50px",
                        padding: "0.25rem 0.5rem",
                      }}
                    >
                      <option value="Subscribers">Subscribers</option>
                      <option value="Revenue">Revenue</option>
                    </Form.Select>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-end",
                    marginTop: "1rem",
                  }}
                >
                  <h2>
                    €{subSummaryPercentage?.totalRevenue?.toLocaleString()}
                  </h2>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                  }}
                >
                  <BarChart {...revenue} />
                </div>
              </div>
            )}
          </div>

          {/* Plans in a 2x2 Grid */}
          <div
            style={{
              flex: 1,
              display: "grid",
              gridTemplateColumns: "repeat(2, 1fr)",
              gridAutoRows: "140px",
              gap: "1rem",
              alignItems: "start",
            }}
          >
            {subSummaryPercentage?.plans?.map((item, key) => {
              const borderColors = ["#F49F0A", "#008CFE", "#219653"];
              const borderColor =
                borderColors[Math.floor(Math.random() * borderColors.length)];
              return (
                <div
                  key={key}
                  style={{
                    backgroundColor: "#fff",
                    borderRadius: "0.6rem",
                    padding: "0.5rem 0.75rem", // smaller padding
                    display: "flex",
                    justifyContent: "space-between",
                    height: "140px", // keep fixed height
                    borderLeft: `6px solid ${borderColor}`,
                    boxSizing: "border-box",
                    overflow: "hidden",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center", // center content vertically
                      gap: "0.12rem",
                      minWidth: 0,
                    }}
                  >
                    <span
                      style={{
                        fontSize: "1.02rem",
                        fontWeight: 500,
                        margin: 0,
                        lineHeight: 1,
                      }}
                    >
                      {item?.name} Plan
                    </span>
                    <h2 style={{ margin: "0.12rem 0", lineHeight: 1.1 }}>
                      {item?.subscriptionCount}
                    </h2>
                    <span
                      style={{
                        color:
                          item?.percentageIncrement >= 0
                            ? "#219653"
                            : "#EB5757",
                        display: "flex",
                        alignItems: "center",
                        margin: 0,
                        lineHeight: 1,
                      }}
                    >
                      {item?.percentageIncrement >= 0 ? (
                        <FiArrowUpRight
                          size={18}
                          style={{ marginRight: "0.4rem" }}
                        />
                      ) : (
                        <FiArrowDownLeft
                          size={18}
                          style={{ marginRight: "0.4rem" }}
                        />
                      )}
                      {parseFloat(item?.percentageIncrement.toFixed(0))}% last
                      month
                    </span>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginLeft: "0.5rem",
                    }}
                  >
                    {item?.percentageIncrement >= 0 ? (
                      <GraphShadowIcon fillColor="#219653" />
                    ) : (
                      <GraphShadowIcon fillColor="#EB5757" />
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      <div className="my-4 d-flex flex-column">
        <div className="mb-5">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div>
              <h6 className="first-font-medium">Monthly Performance Metrics</h6>
              <p>Detailed monthly performance breakdown</p>
            </div>
          </div>

          {loadingTable ? (
            <div className="text-center p-5 m-auto">
              <Spinner />
              <br /> <h4>loading...</h4>
            </div>
          ) : (
            <>
              {/* Monthly Performance Metrics Table */}
              {showMonthlyTable && (
                <Table responsive className="table">
                  <thead>
                    <tr>
                      <th>
                        <label className="fw-normal">Month</label>
                      </th>
                      <th>
                        <label className="fw-normal">Total Minutes</label>
                      </th>
                      <th>
                        <label className="fw-normal">Success Rate</label>
                      </th>
                      <th>
                        <label className="fw-normal">Avg Duration</label>
                      </th>
                      <th>
                        <label className="fw-normal">Revenue</label>
                      </th>
                      <th>
                        <label className="fw-normal">Cost</label>
                      </th>
                      <th>
                        <label className="fw-normal">Profit Margin</label>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {monthlyPerformanceData?.map((item, key) => (
                      <tr
                        key={key}
                        className="align-middle content-container-height"
                      >
                        <td>
                          <span className="fw-medium">{item.month}</span>
                        </td>
                        <td>
                          <span className="text-secondary">
                            {item.totalMinutes.toLocaleString()}
                          </span>
                        </td>
                        <td>
                          <span
                            className="px-2 py-1 rounded"
                            style={{
                              backgroundColor: "#d4edda",
                              color: "#155724",
                              fontSize: "0.875rem",
                              fontWeight: "500",
                            }}
                          >
                            {item.successRate}%
                          </span>
                        </td>
                        <td>
                          <span className="text-secondary">
                            {item.avgDuration}
                          </span>
                        </td>
                        <td>
                          <span className="text-secondary">{item.revenue}</span>
                        </td>
                        <td>
                          <span className="text-secondary">{item.cost}</span>
                        </td>
                        <td>
                          <span
                            style={{
                              color: "#28a745",
                              fontWeight: "500",
                            }}
                          >
                            {item.profitMargin}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              )}

              <button
                onClick={() => setShowMonthlyTable(!showMonthlyTable)}
                className="btn-secondary-outline font-size-sm first-font-medium px-3 w-100"
              >
                {showMonthlyTable ? "Hide Table" : "Show Table"}
              </button>
            </>
          )}
        </div>

        <div className="">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div>
              <h6 className="first-font-medium">Multi-Language Performance</h6>
              <p>Usage and success rates across different languages</p>
            </div>
          </div>

          {/* Multi-Language Performance Table */}
          {loadingTable ? (
            <div className="text-center p-5 m-auto">
              <Spinner />
              <br /> <h4>loading...</h4>
            </div>
          ) : (
            <>
              {showLanguageTable && (
                <Table responsive className="table">
                  <thead>
                    <tr>
                      <th>
                        <label className="fw-normal">Language</label>
                      </th>
                      <th>
                        <label className="fw-normal">Total Minutes</label>
                      </th>
                      <th>
                        <label className="fw-normal">Success Rate</label>
                      </th>
                      <th>
                        <label className="fw-normal">Market Share</label>
                      </th>
                      <th>
                        <label className="fw-normal">Supported Regions</label>
                      </th>
                      <th>
                        <label className="fw-normal">Performance</label>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {multiLanguageData?.map((item, key) => (
                      <tr
                        key={key}
                        className="align-middle content-container-height"
                      >
                        <td>
                          <span className="fw-medium">{item.language}</span>
                        </td>
                        <td>
                          <span className="text-secondary">
                            {item.totalMinutes.toLocaleString()}
                          </span>
                        </td>
                        <td>
                          <span
                            className="px-2 py-1 rounded"
                            style={{
                              backgroundColor:
                                item.successRate >= 80 ? "#d4edda" : "#fff3cd",
                              color:
                                item.successRate >= 80 ? "#155724" : "#856404",
                              fontSize: "0.875rem",
                              fontWeight: "500",
                            }}
                          >
                            {item.successRate}%
                          </span>
                        </td>
                        <td>
                          <span className="text-secondary">
                            {item.marketShare}
                          </span>
                        </td>
                        <td>
                          <span className="text-secondary">
                            {item.supportedRegions}
                          </span>
                        </td>
                        <td>
                          <span
                            className="px-2 py-1 rounded"
                            style={{
                              backgroundColor:
                                item.performance === "Excellent"
                                  ? "#cce7ff"
                                  : "#fff3cd",
                              color:
                                item.performance === "Excellent"
                                  ? "#004085"
                                  : "#856404",
                              fontSize: "0.875rem",
                              fontWeight: "500",
                            }}
                          >
                            {item.performance}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              )}

              <button
                onClick={() => setShowLanguageTable(!showLanguageTable)}
                className="btn-secondary-outline font-size-sm first-font-medium px-3 w-100"
              >
                {showLanguageTable ? "Hide Table" : "Show Table"}
              </button>
            </>
          )}
        </div>
      </div>
      <ModalComponent
        size={undefined}
        showModal={smallShow}
        hideModal={() => setSmallShow(false)}
      >
        {activeModalTab === "delete" && (
          <div className="px-3">
            <div className="my-3 text-center">
              <img src={info} width="120px" />
            </div>
            <p className="fs-5 fw-bold">
              Confirm deletion of selected Company(ies)
            </p>
            <p className="text-secondary">
              Are you sure you want to delete the selected company(ies)? <br />
              Removing this company(ies) would remove all access and history on
              JobPro.
            </p>
            <div className="pt-3 pb-4">
              <button
                disabled={loading}
                type="button"
                onClick={() => handleDeleteCompany()}
                className="btn btn-danger w-100 border-0 py-3 rounded-5"
              >
                Confirm {smallLoading && <Spinner size="sm" />}
              </button>
            </div>
          </div>
        )}
      </ModalComponent>

      <ModalComponent
        size="xl"
        showModal={show}
        hideModal={() => setShow(false)}
      >
        <div className="position-absolute w-100 p-3 mb-5">
          <p className="d-flex justify-content-end pb-4">
            <button className="btn p-0 ">
              <AiOutlineClose onClick={() => setShow(false)} size={20} />
            </button>
          </p>
        </div>
        <div className="px-4 py-5">
          <div className="mt-3 mb-5">
            <span className="bg-white p-3 rounded-3">
              <img src={Logo} />
            </span>
          </div>
          {/* <div className='d-flex justify-content-between px-4 py-5'>
                        <div>
                            <button onClick={() => setActiveUser("All")} className={activeUser === "All" ? "btn-primary-outline font-size-sm first-font-medium px-3 me-3 py-2" : "btn-secondary-outline font-size-sm first-font-medium px-3 me-3 py-2"}>All Users</button>
                            <button onClick={() => setActiveUser("Deactivated")} className={activeUser === "Deactivated" ? "btn-primary-outline font-size-sm first-font-medium px-3 me-3 py-2" : "btn-secondary-outline font-size-sm first-font-medium px-3 me-3 py-2"}>Deactivated Employees</button>
                        </div>
                        <div className='d-flex justify-content-between'>
                            <button onClick={() => setActiveUser("All")} className="btn-primary font-size-sm first-font-medium px-3 me-3 py-2"><FiPlus size={20} /> Invite Employee</button>
                            <button onClick={() => setActiveUser("Deactivated")} className="btn-secondary-outline font-size-sm first-font-medium px-3 me-3 py-2"><GoCircleSlash size={20} /> Suspend Employee</button>
                            <Form className='my-auto'>
                                <Form.Control type='text' placeholder='Search' className='rounded-4 search-input light-text' />
                            </Form>
                        </div>
                    </div> */}

          {activeModalTab === "history" && (
            <div>
              <Table responsive className="table">
                <thead>
                  <tr>
                    <th>
                      <label className="fw-normal">SN</label>
                    </th>
                    <th>
                      <label className="fw-normal">Company Name</label>
                    </th>
                    <th>
                      <label className="fw-normal">Country</label>
                    </th>
                    <th>
                      <label className="fw-normal">Email</label>
                    </th>
                    <th>
                      <label className="fw-normal">Plan</label>
                    </th>
                    <th>
                      <label className="fw-normal">Registration Date</label>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="align-middle">
                    <td>
                      <Form.Check />
                    </td>
                    <td>{selectedCompany?.companyName}</td>
                    <td>
                      <span className="text-secondary">
                        {selectedCompany?.country}
                      </span>
                    </td>
                    <td>
                      <span className="text-secondary">
                        {selectedCompany?.email}
                      </span>
                    </td>
                    <td>
                      <span className="text-secondary">
                        {selectedCompany?.planName}
                      </span>
                    </td>
                    {/* <td><span className='text-secondary'>{selectedCompany?.staffSize}</span></td> */}
                    <td>
                      <span className="text-secondary">
                        {FormattedDateTime(
                          selectedCompany?.registrationDate || ""
                        )}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
          )}
        </div>
      </ModalComponent>

      {loading ? (
        <div className="text-center p-5 m-auto">
          <Spinner />
          <br /> <h4>loading...</h4>
        </div>
      ) : (
        <div className="row">
          <div className="col-lg-6 row">
            <div className="subscription py-4 px-5 bg-white rounded-4">
              <div className="">
                <h6 className="second-font">Call Type Distribution</h6>
                <p className="dark-text">Minutes breakdown by call purpose</p>
              </div>
              <div className="row">
                <div className="col-md-8">
                  <Chart
                    options={options}
                    series={series}
                    type="donut"
                    height={300}
                  />
                </div>
                <div className="col-md-4 d-flex align-items-center">
                  <div>
                    {legendItems.map((item, index) => (
                      <div
                        key={index}
                        className="d-flex align-items-center mb-3"
                      >
                        <div
                          style={{
                            width: "12px",
                            height: "12px",
                            backgroundColor: item.color,
                            borderRadius: "50%",
                            marginRight: "10px",
                          }}
                        ></div>
                        <span className="text-dark fs-6">{item.label}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            {activityTab === "Subscribers" && (
              <div className="subscription py-4 px-5 bg-white rounded-4">
                <div className="d-flex justify-content-between"></div>
                <div className="">
                  <h6 className="second-font">Success Rate by Call Type</h6>
                  <p className="dark-text">Performance comparison across different call purposes</p>
                </div>
                <div className="d-flex align-item-center justify-content-center text-center">
                  <BarChart {...subscription} />
                </div>
              </div>
            )}
            {activityTab === "Revenue" && (
              <div className="revenue py-4 px-5 bg-white rounded-4">
                <div className="d-flex justify-content-between">
                  <span className="font-size-mid first-font-medium">
                    {summaryData?.selectedPackage} Revenue Activity{" "}
                    <BiDotsHorizontalRounded className="ms-4" />
                  </span>
                  <div className="w-50 d-flex align-item-end justify-content-end">
                    <Form.Select
                      value={activityTab}
                      onChange={(e) => setActivityTab(e.target.value)}
                      className="w-75 rounded-5"
                    >
                      <option value="Subscribers">Subscribers</option>
                      <option value="Revenue">Revenue</option>
                    </Form.Select>
                  </div>
                </div>
                <div className="d-flex align-items-end">
                  <h2 className="second-font">
                    €{subSummaryPercentage?.totalRevenue?.toLocaleString()}
                  </h2>
                  {/* <p className='dark-text ps-3'>this month</p> */}
                </div>
                <div className="d-flex align-item-center justify-content-center text-center">
                  <BarChart {...revenue} />
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      <div className="mt-5">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div>
            <h6 className="first-font-medium">Call Type Performance Details</h6>
            <p>Comprehensive metrics for each call type</p>
          </div>
        </div>

        {/* Call Type Performance Table */}
        {loadingTable ? (
          <div className="text-center p-5 m-auto">
            <Spinner />
            <br /> <h4>loading...</h4>
          </div>
        ) : (
          <>
            {showCallTypeTable && (
              <Table responsive className="table">
                <thead>
                  <tr>
                    <th>
                      <label className="fw-normal">Call Type</label>
                    </th>
                    <th>
                      <label className="fw-normal">Total Minutes</label>
                    </th>
                    <th>
                      <label className="fw-normal">Success Rate</label>
                    </th>
                    <th>
                      <label className="fw-normal">Avg Duration</label>
                    </th>
                    <th>
                      <label className="fw-normal">Avenue Share</label>
                    </th>
                    <th>
                      <label className="fw-normal">Performance</label>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {callTypeData?.map((item, key) => (
                    <tr
                      key={key}
                      className="align-middle content-container-height"
                    >
                      <td>
                        <span className="fw-medium">{item.callType}</span>
                      </td>
                      <td>
                        <span className="text-secondary">
                          {item.totalMinutes.toLocaleString()}
                        </span>
                      </td>
                      <td>
                        <span
                          className="px-2 py-1 rounded"
                          style={{
                            backgroundColor:
                              item.successRate >= 80 ? "#d4edda" : "#fff3cd",
                            color:
                              item.successRate >= 80 ? "#155724" : "#856404",
                            fontSize: "0.875rem",
                            fontWeight: "500",
                          }}
                        >
                          {item.successRate}%
                        </span>
                      </td>
                      <td>
                        <span className="text-secondary">
                          {item.avgDuration}
                        </span>
                      </td>
                      <td>
                        <span className="text-secondary">
                          {item.revenueShare}
                        </span>
                      </td>
                      <td>
                        <span
                          className="px-2 py-1 rounded"
                          style={{
                            backgroundColor:
                              item.performance === "Excellent"
                                ? "#cce7ff"
                                : "#fff3cd",
                            color:
                              item.performance === "Excellent"
                                ? "#004085"
                                : "#856404",
                            fontSize: "0.875rem",
                            fontWeight: "500",
                          }}
                        >
                          {item.performance}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}

            <button
              onClick={() => setShowCallTypeTable(!showCallTypeTable)}
              className="btn-secondary-outline font-size-sm first-font-medium px-3 w-100"
            >
              {showCallTypeTable ? "Hide Table" : "Show Table"}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default SophiaVoiceAgent;

